import { Injectable } from '@angular/core';
import { ApiServiceService } from '../api-service/api-service.service';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ActivatedRoute } from '@angular/router';
import { DownloadService } from '../download/download.service';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ModalServiceService } from '../modal-service/modal-service.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '../common-utils/common-utils.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentActionsService {
  viewExtensions: any = ['pdf', 'gif', 'png', 'txt', 'jpg', 'jpeg'];
  // user: any = this.context.user?this.context.user.login:null;
  constructor(private router: ActivatedRoute,
    private translate: AfTranslateFactory,
    private apiProperties: ApiPropertiesFactory,
    private context: ContextFactory,
    private loader: LoaderFactory,
    private apiService:ApiServiceService,
    private downloadService: DownloadService,
    private modalService: ModalServiceService,
    private commonUtilsService: CommonUtilsService) { }

  doAction(configuration: any){
    let action: any = configuration.action;
    let file: any = configuration.file;
    let type: any = configuration.type;

    if (action === 'open' && file.extension) {
      action = this.viewExtensions.includes(file.extension.toLowerCase()) ? 'view' : 'edit';
    } else if (action === 'open' && file.extension === undefined){
      action = 'edit';
    }
    let url: string = '';
    switch (action) {
      case 'edit':
        this.editOfficeOnline(file, type);
        break;
      case 'view':
        this.viewDocument(file);
        break;
      case 'download':
        url = 'file='+ file.editPath;
        this.downloadDocument(configuration, url);
        break;
      case 'sibila':
        this.openSibila(file);
        break;
      case 'downloadField':
        url = 'file='+ file.editPath + '&conceptDataId=' + file.conceptDataId;
        this.downloadDocument(configuration, url);
        break;
    }
  }

  editOfficeOnline(file: any, typeDocument: any){
    let id = file.reportDocumentId && file.reportDocumentId !== -1?file.reportDocumentId:file.documentObjectId;
    let type = file.reportDocumentId && file.reportDocumentId !== -1?'report-document':'document';
    if(typeDocument === 'template'){
      id = file.documentId;
      type = 'template';
    }
    window.open('/office-online/'+type+'/'+id, '_blank');
  }

  downloadDocument(configuration: any, url: any){
    this.loader.openLoader('download-document-actions');
    this.apiService.getBlob('utils/file/download?' + url)
      .then((data:any) => {
        let fileName: any = data.fileName?data.fileName:configuration.file.name;
        this.downloadService.triggerDownload(data.blob, fileName);
        this.loader.closeLoader(['download-document-actions']);
        if(configuration.returnCallback){
          configuration.successCallback();
        }
      }, (error:any) => {
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('document-actions.error-download-document') });
      });
  }

  viewDocument(file: any){
    let url = '';
    if(file.editPath){
      url += 'file='+file.editPath;
    }
    let conceptObjectId = file.conceptObjectId?file.conceptObjectId:this.router.snapshot.params['conceptObjectId'];
    if(conceptObjectId){
      url += url?'&':'';
      url += 'conceptObjectId='+conceptObjectId;
    }
    let clientId = file.clientId?file.clientId:this.router.snapshot.params['clientId'];
    if(clientId){
      url += url?'&':'';
      url += 'clientId='+clientId;
    }
    if(file.ispublic === 'true'){
      url += url?'&':'';
      url += 'ispublic='+file.ispublic;
    }
    if(file.viewform === 'true' || file.viewform === true){
      url += url?'&':'';
      url += 'viewform=true';
    }
    this.apiService.getBlob('utils/file/view?'+ url)
      .then((data:any) => {
        window.open(URL.createObjectURL(data.blob), '_blank');
      }, (error:any) => {});
  }

  openSibila(file: any){
    let sibilaUrl: any = this.apiProperties.onlineSibilaUrl.replace(/\{0\}/g, this.context.user.externalAccessId);
    let formSibila = $('<form style="display:none" action="'+sibilaUrl+'" id="sibilaForm" target="_blank" method="post"></form>');
    if (file.text) {
      let inputText = $('<input/>');
      inputText.attr('type', 'hidden');
      inputText.attr('name', 'textoSibila');
      inputText.attr('value', file.text);
      formSibila.append(inputText);
    }
    $('body').append(formSibila);
    formSibila.submit();
    setTimeout(()=> {
      $('#sibilaForm').remove();
    }, 500)
  }

  newDocument(configuration: any){
    return new Promise((resolve, reject) => {
      if(this.commonUtilsService.isIE()){
        this.modalService.errorModal({ text: this.translate.instant('common.error-ie-compatibility') });
        reject("error");
      }else{
        let configurationModal : any = {
          list: configuration.templatesList,
          concept: configuration.concept,
          type:'template-document',
          listDocuments: configuration.listTemplates
        }
        this.modalService.newDocument(configurationModal)
          .subscribe((result:any)=>{
            if(result.result ==='ok'){
              if(this.duplicatedDocument(result.name, configuration.listTemplates)){
                this.modalService.errorModal({ text: this.translate.instant('common.the-document')+"'"+result.name+"'"+this.translate.instant('documentation-list.is-already-added') });
                reject("error");
              }else{
                this.loader.openLoader('documentation-list-up-or-create');
                resolve(this.createNewFile(result, configuration));
              }
            }
          })
      }
    })
  }

  duplicatedDocument(name:any, listTemplates: any){
    for(let i = 0; i < listTemplates.length; i++){
      if(name === listTemplates[i].name){
        return true;
      }
    }
    return false;
  }

  createNewFile(result:any, configuration: any){
    return new Promise((resolve, reject) => {
      this.apiService.add(result.url, {name: result.name})
        .then((data:any)=>{
          resolve(this.configureNewDocument(data, configuration));
        }, (errorData:any)=>{
          this.loader.closeError();
          this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-document') +"'"+ result.name + "'" });
          reject("error");
        });
    })
  }

  configureNewDocument(document:any, configuration: any){
    return new Promise((resolve) => {
      document.source = this.translate.instant('templates-concept.custom-template');
      document.type = "Front";
      document.id = document.documentId;
      document.listValueId = document.id;
      document.text = document.name;
      configuration.concept.templatesConcept.push(document);
      // configuration.templatesList.push(document);
      this.loader.closeLoader(['documentation-list-up-or-create']);
      this.doAction({ action: 'open', file: document, type: 'template' });
      this.modalService.successModal({ text: this.translate.instant('templates-concept.create-template-ok') });
      resolve(document);
    })

  }

}
